import { t } from 'i18next';

export const steps = () => {
    return [t('survey.step1'), t('survey.step2'), t('survey.step3')];
};

export enum LEVEL {
    A0 = 'A0',
    A1 = 'A1',
    A2 = 'A2',
    B1 = 'B1',
    B2 = 'B2',
    C1 = 'C1',
    C2 = 'C2',
}

export const levels = [LEVEL.A0, LEVEL.A1, LEVEL.A2, LEVEL.B1, LEVEL.B2, LEVEL.C1, LEVEL.C2];

export const levelOptions = [
    {
        value: LEVEL.A1,
        label: 'A1',
    },
    {
        value: LEVEL.A2,
        label: 'A2',
    },
    {
        value: LEVEL.B1,
        label: 'B1',
    },
    {
        value: LEVEL.B2,
        label: 'B2',
    },
    {
        value: LEVEL.C1,
        label: 'C1',
    },
    {
        value: LEVEL.C2,
        label: 'C2',
    },
];

export enum ENGLISH_EXPERIENCE {
    Beginner = '1-3years',
    Developing = '3-5years',
    Experienced = '5-10years',
    Proficient = 'over10years',
}

export const englishExperienceOptions = () => {
    return [
        {
            value: ENGLISH_EXPERIENCE.Beginner,
            label: t('survey.form.englishLearningExperience.options.1-3_Years'),
        },
        {
            value: ENGLISH_EXPERIENCE.Developing,
            label: t('survey.form.englishLearningExperience.options.3-5_Years'),
        },
        {
            value: ENGLISH_EXPERIENCE.Experienced,
            label: t('survey.form.englishLearningExperience.options.5-10_Years'),
        },
        {
            value: ENGLISH_EXPERIENCE.Proficient,
            label: t('survey.form.englishLearningExperience.options.10+_Years'),
        },
    ];
};

export enum DAILY_COMMITMENT {
    Casual = 'casual',
    Regular = 'regular',
    Serious = 'serious',
    Intense = 'intense',
}

export const dailyCommitmentOptions = () => {
    return [
        {
            value: DAILY_COMMITMENT.Casual,
            label: t('survey.form.dailyLearningCommitment.options.casual'),
        },
        {
            value: DAILY_COMMITMENT.Regular,
            label: t('survey.form.dailyLearningCommitment.options.regular'),
        },
        {
            value: DAILY_COMMITMENT.Serious,
            label: t('survey.form.dailyLearningCommitment.options.serious'),
        },
        {
            value: DAILY_COMMITMENT.Intense,
            label: t('survey.form.dailyLearningCommitment.options.intense'),
        },
    ];
};

export enum LEARNING_GOAL {
    Ielts = 'ielts',
    Toefl = 'toefl',
    Toeic = 'toeic',
    Pte = 'pte',
    Other = 'other',
}

export const learningGoalOptions = () => {
    return [
        {
            value: LEARNING_GOAL.Ielts,
            label: t('survey.form.learningGoal.options.ielts'),
        },
        {
            value: LEARNING_GOAL.Toefl,
            label: t('survey.form.learningGoal.options.toefl'),
        },
        {
            value: LEARNING_GOAL.Toeic,
            label: t('survey.form.learningGoal.options.toeic'),
        },
        {
            value: LEARNING_GOAL.Pte,
            label: t('survey.form.learningGoal.options.pte'),
        },
        {
            value: LEARNING_GOAL.Other,
            label: t('survey.form.learningGoal.options.other'),
        },
    ];
};

export enum LEARNING_STYLE {
    Visual = 'visual',
    Auditory = 'auditory',
    Interactive = 'interactive',
    All = 'all',
}

export const learningStyleOptions = () => {
    return [
        {
            value: LEARNING_STYLE.Visual,
            label: t('survey.form.learningStyle.options.visual'),
        },
        {
            value: LEARNING_STYLE.Auditory,
            label: t('survey.form.learningStyle.options.auditory'),
        },
        {
            value: LEARNING_STYLE.Interactive,
            label: t('survey.form.learningStyle.options.interactive'),
        },
        {
            value: LEARNING_STYLE.All,
            label: t('survey.form.learningStyle.options.all'),
        },
    ];
};

export enum AGE_GROUP {
    Child = 'child',
    Teen = 'teen',
    Adult = 'adult',
    Senior = 'senior',
}

export const ageGroupOptions = () => {
    return [
        {
            value: AGE_GROUP.Child,
            label: t('survey.form.ageGroup.options.child'),
        },
        {
            value: AGE_GROUP.Teen,
            label: t('survey.form.ageGroup.options.teen'),
        },
        {
            value: AGE_GROUP.Adult,
            label: t('survey.form.ageGroup.options.adult'),
        },
        {
            value: AGE_GROUP.Senior,
            label: t('survey.form.ageGroup.options.senior'),
        },
    ];
};

export enum LEARNING_PREFERENCE {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Night = 'night',
}

export const learningPreferenceOptions = [
    {
        value: LEARNING_PREFERENCE.Morning,
        label: 'Morning (6AM - 12PM)',
    },
    {
        value: LEARNING_PREFERENCE.Afternoon,
        label: 'Afternoon (12PM - 6PM)',
    },
    {
        value: LEARNING_PREFERENCE.Evening,
        label: 'Evening (6PM - 10PM)',
    },
    {
        value: LEARNING_PREFERENCE.Night,
        label: 'Night (10PM - 6AM)',
    },
];

export enum LANGUAGE {
    EN = 'en',
    VI = 'vi',
}

/**
 * Profiles created by older sign-up flows store the language name ("English") instead of the
 * option code ("en"); map it so the select shows the saved value instead of an empty box.
 */
export const toLanguageCode = (value?: string | null): string | undefined => {
    if (!value) return undefined;
    const normalized = value.trim().toLowerCase();
    if (['en', 'english', 'tiếng anh'].includes(normalized)) return LANGUAGE.EN;
    if (['vi', 'vietnamese', 'tiếng việt'].includes(normalized)) return LANGUAGE.VI;
    return value;
};

export const languageOptions = () => {
    return [
        {
            value: LANGUAGE.EN,
            label: t('survey.form.nativeLanguage.options.en'),
        },
        {
            value: LANGUAGE.VI,
            label: t('survey.form.nativeLanguage.options.vi'),
        },
    ];
};
